"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showTaggedUnionInterpreter = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
/**
 *  @since 0.0.1
 */
exports.showTaggedUnionInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.ShowURI,
    taggedUnion: function (tag, types, _name, config) { return function (env) {
        var shows = utils_1.mapRecord(types, function (a) { return a(env).show.show; });
        return new hkt_1.ShowType(config_1.showApplyConfig(config)({
            show: function (a) { return shows[a[tag]](a); }
        }, env, {}));
    }; }
}); });
